import React from "react";
import PropTypes from "prop-types";
//
import Drawer from "@mui/material/Drawer";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import makeStyles from "@mui/styles/makeStyles";
//
import { useTranslation } from "@limitless/common/hooks";
import { useWebSockets } from "@limitless/common/hooks/web-sockets/WebSocketsContext";
import Accordion from "@limitless/modern/surfaces/accordion/Accordion";
import Divider from "@limitless/modern/data-display/divider/Divider";
const useStyles = makeStyles({
  drawerContainer: {
    top: 69,
    bottom: 0,
    height: "100%",
    width: 500,
    zIndex: 1199
  },
  templateCols: {
    height: "calc(100vh - 75px)",
    display: "grid",
    gridTemplateColumns: "1fr",
    gridTemplateRows: "1fr 45px",
    gridTemplateAreas: `"main"
                            "footer"`
  },
  mainContainer: {
    zIndex: 1,
    gridArea: "main",
    overflow: "auto",
    padding: 16
  },
  closeContainer: {
    gridArea: "footer",
    display: "block",
    width: "100%",
    textAlign: "center"
  },
  closeButton: {
    "&:hover": {
      backgroundColor: "rgba(0, 0, 0, 0.03)"
    },
    fontWeight: 400
  }
});
const WebsocketDebugDrawer = ({
  onClose
}) => {
  const classes = useStyles();
  const {
    t
  } = useTranslation();
  const {
    wsStatus,
    getWebSocketSubscriptionStatus
  } = useWebSockets();
  const {
    groupTopics,
    systemTopics
  } = React.useMemo(() => {
    const allTopics = getWebSocketSubscriptionStatus();
    const groupTopics = {
      topics: {},
      title: "Group Topics",
      total: 0,
      numOfSuccess: 0
    };
    const systemTopics = {
      topics: {},
      title: "System Topics",
      total: 0,
      numOfSuccess: 0
    };
    Object.keys(allTopics).map(topicKey => {
      const status = allTopics[topicKey];
      const isSuccess = status === "success";
      if (topicKey.includes("group")) {
        groupTopics.topics = {
          ...groupTopics.topics,
          [topicKey]: status
        };
        groupTopics.total++;
        if (isSuccess) {
          groupTopics.numOfSuccess++;
        }
      } else {
        systemTopics.topics = {
          ...systemTopics.topics,
          [topicKey]: status
        };
        systemTopics.total++;
        if (isSuccess) {
          systemTopics.numOfSuccess++;
        }
      }
    });
    return {
      systemTopics,
      groupTopics
    };
  }, []);
  const eventStream = React.useMemo(() => {
    if (process.env.REACT_APP_WS_HISTORY) {
      const events = window.wsEvents.map(e => e.event).reverse();
      return /*#__PURE__*/React.createElement(Accordion, {
        title: "Web Socket Events"
      }, events.map(event => {
        const {
          timestamp,
          type,
          action,
          topic
        } = event;
        return /*#__PURE__*/React.createElement(Grid, {
          item: true,
          key: timestamp,
          style: {
            marginTop: 8
          }
        }, /*#__PURE__*/React.createElement(Typography, {
          variant: "caption"
        }, timestamp), /*#__PURE__*/React.createElement(Grid, {
          container: true,
          justifyContent: "space-between",
          spacing: 1
        }, /*#__PURE__*/React.createElement(Grid, {
          item: true
        }, /*#__PURE__*/React.createElement(Typography, {
          variant: "body2"
        }, `${type} / ${action}`)), /*#__PURE__*/React.createElement(Grid, {
          item: true
        }, /*#__PURE__*/React.createElement(Typography, {
          variant: "body2"
        }, topic))), /*#__PURE__*/React.createElement(Divider, null));
      }));
    } else {
      return null;
    }
  }, []);
  const renderStatusAccordion = topicDetails => {
    const {
      title,
      topics,
      numOfSuccess,
      total
    } = topicDetails;
    return /*#__PURE__*/React.createElement(Grid, {
      item: true
    }, /*#__PURE__*/React.createElement(Accordion, {
      title: `${title} ${numOfSuccess}/${total} connected`
    }, Object.keys(topics).map(topic => {
      return /*#__PURE__*/React.createElement(Grid, {
        container: true,
        key: topic,
        justifyContent: "space-between",
        style: {
          padding: 8
        }
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true
      }, /*#__PURE__*/React.createElement(Typography, {
        variant: "body2"
      }, topic)), /*#__PURE__*/React.createElement(Grid, {
        item: true
      }, /*#__PURE__*/React.createElement(Typography, {
        variant: "body2"
      }, topics[topic])));
    })));
  };
  return /*#__PURE__*/React.createElement(Drawer, {
    anchor: "right",
    open: true,
    onClose: onClose,
    classes: {
      paper: classes.drawerContainer
    },
    variant: "persistent"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      height: "100%"
    }
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    className: classes.templateCols
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    id: "cont-1",
    className: classes.mainContainer
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    justifyContent: "space-between"
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle1"
  }, t("Connection Status"))), /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle1"
  }, wsStatus))), renderStatusAccordion(groupTopics), renderStatusAccordion(systemTopics), eventStream), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    className: classes.closeContainer
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: onClose,
    className: classes.closeButton
  }, t("Close"))))));
};
WebsocketDebugDrawer.propTypes = {
  onClose: PropTypes.func
};
export default WebsocketDebugDrawer;